import type { ComponentType } from 'react';

import { BackgroundSQR, USDC, USDT } from '@ui/uikit/components/icons/poly';
import { formatAmount } from '@ui/uikit/utils';

import { Chip, ChipSize, ChipSubVariant, ChipVariant } from '../../../Chip';

interface CurrencyConfig {
  icon: ComponentType<{ className?: string }> | null;
  displayName?: string;
}

export const currencyMap: Record<string, CurrencyConfig> = {
  USDT: {
    icon: USDT,
  },
  USDC: {
    icon: USDC,
  },
  SQR: {
    icon: BackgroundSQR,
  },
  'USDT-SQR-EXCH': {
    icon: BackgroundSQR,
    displayName: 'SQR',
  },
  DEFAULT: {
    icon: null,
    displayName: '',
  },
};

interface TokenRewardChipProps {
  offerAmount: number | string;
  offerCurrency: string;
}

const TokenRewardChip = ({ offerAmount, offerCurrency }: TokenRewardChipProps) => {
  const currencyConfig = currencyMap[offerCurrency] || currencyMap.DEFAULT;

  const amount = formatAmount(Number(offerAmount));

  return (
    <Chip
      variant={ChipVariant.WHITE}
      subVariant={ChipSubVariant.BORDERED}
      size={ChipSize.LARGE}
      icon={currencyConfig.icon}
      text={`${amount} ${currencyConfig.displayName || offerCurrency || ''}`}
    />
  );
};

export { TokenRewardChip };
